<template>
    <div>
        <template v-if="hasError">
            <p class="text-danger">{{ error }}</p>
        </template>
        <template v-if="isFree">
            <b-button variant="primary"
                      :disabled="isBusy"
                      @click="handleEnrol"
                      :class="{
                        'btn-block btn-white btn-slimpad': !inline,
                        'btn-primary': inline,
                      }"><slot>Take Assessment</slot></b-button>
        </template>
    </div>
</template>

<script>
    import { globalEventFire } from '../tracker.js';

    export default {
        props: {

            exam: {
                type: Object,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            },
            isNewlyRegistered: {
                type: Boolean,
                required: false,
            },
            inline: {
                type: Boolean,
                required: false,
                default: false,
            },
            purchaseIntent: { // Not used, but tells us whether it's a subscription or free intent
                type: String,
                required: false,
            },
        },

        data() {
            return {
                isBusy: false,
                hasError: false,
                error: '',
                currentUrl: '',
                isFree: false,
                isAuth: false,
                isSubscribed: false,
                isSchoolUser: false,
            }
        },

        mounted() {
            this.currentUrl = window.location.pathname;

            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                    this.isSchoolUser = this.user.isSchoolUser;
                }
                this.isSubscribed = window.virtuoso.is_subscribed;
            }

            if(this.isSubscribed) {
                this.isFree = this.exam.is_free_subscription;
            } else {
                this.isFree = this.exam.is_free;
            }
        },

        methods: {
            openModal() {
                this.$refs['buyModal'].show('buyModal');
            },

            // Handle enrolment
            handleEnrol() {
                this.hasError = false;
                this.error = '';

                this.isBusy = true;

                if(this.isFree) {
                    this.fireEnrolment();
                }
            },

            // Actually enrol them
            fireEnrolment() {
                // Fire it
                let queryStringAppend = this.isNewUser ? '?newUser=true&enrolled=true' : '?enrolled=true';
                axios.post('/api/exam/' + this.exam.id + '/enrol')
                    .then((response) => {
                        if(response.data.success) {
                            // Fire analytics event
                            this.fireAnalytics(response.data.enrolment_id ?? 0);
                            location.href = response.data.redirect_uri + queryStringAppend;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            },

            // Fire analytics
            fireAnalytics(enrolment_id) {
                globalEventFire('ExamEnrolment', 'Exam', {
                    'name': this.exam.name,
                    'analytics_tag': this.exam.name.replace(/ /g,"_"),
                    'user_id': this.user.id,
                    'email': this.user.email
                });
            },
        }
    }
</script>
